import useProductForm from "./hooks/useProductForm";
import ProductFormHeader from "./components/ProductFormHeader";
import BasicInfoSection from "./components/BasicInfoSection";
import DescriptionsSection from "./components/DescriptionsSection";
import VariantsSection from "./components/variants/VariantsSection";
import LogisticsSidebar from "./components/LogisticsSidebar";
import ActionsSidebar from "./components/ActionsSidebar";
import "./style.css";

export default function ProductForm({
  categories,
  brands,
  showModal,
  setShowModal,
  productToEdit,
  productId,
  addProduct,
  onSuccess,
}) {
  const form = useProductForm({
    showModal,
    setShowModal,
    productToEdit,
    productId,
    addProduct,
    onSuccess,
  });

  if (!showModal) return null;

  return (
    <div className="product-form-page">
      <ProductFormHeader
        productId={productId}
        productToEdit={productToEdit}
        error={form.error}
        categories={categories}
        brands={brands}
        onClose={form.handleClose}
      />

      <form onSubmit={form.handleSubmit} noValidate>
        <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_300px] gap-5 items-start">
          <div className="space-y-5 min-w-0">
            <BasicInfoSection
              form={form}
              categories={categories}
              brands={brands}
            />
            <DescriptionsSection form={form} />
            <VariantsSection form={form} />
          </div>

          <aside className="space-y-4 xl:sticky xl:top-4">
            <ActionsSidebar form={form} categories={categories} />
            <LogisticsSidebar form={form} />
          </aside>
        </div>
      </form>
    </div>
  );
}
